import React, { Component } from "react";

import {
  CButton,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import Breadcrumb from "../../../components/Breadcrumb";
import Loading from "../../../components/Loading";
import ProtectedRoute from "../../../components/ProtectedRoute";
import DataTable from "../../../components/Tables/tables";
import URL from "../../../config/api";
import axios from "../../../config/axios";

class PedagogicalFollowUpsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      list: [],
      showDeleteModal: false,
      itemToDelete: null
    };

    this.insertAction = this.insertAction.bind(this);
    this.editAction = this.editAction.bind(this);
    this.deleteAction = this.deleteAction.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
  }

  componentDidMount() {
    this.props.setObj(
      this.props.currentRoute,
      this.props.currentRoute,
      this.props.currentRoute
    );
    this.getPedagogicalFollowUps();
  }

  getPedagogicalFollowUps = () => {
    this.setState({ loading: true });

    axios
      .get(
        `${URL.api}pedagogical/follow-ups/list?user_id=${this.props.user.user.id}`,
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(response => {
        console.log("Resposta da API:", response.data); // Debug
        this.setState({
          list: response.data.data || [],
          loading: false
        });
      })
      .catch(error => {
        console.error("Erro ao buscar acompanhamentos pedagógicos:", error);
        this.setState({
          loading: false,
          list: []
        });
      });
  };

  insertAction = () => {
    this.props.history.push(`/pedagogical-follow-ups/create`);
  };

  editAction = row => {
    this.props.history.push(`/pedagogical-follow-ups/create/${row.id}`);
  };

  allocateAction = row => {
    this.props.history.push(`/pedagogical-follow-ups/allocate/${row.id}`);
  };

  deleteAction = row => {
    this.setState({
      showDeleteModal: true,
      itemToDelete: row
    });
  };

  confirmDelete = async () => {
    const { itemToDelete } = this.state;

    this.setState({
      loading: true,
      showDeleteModal: false,
      itemToDelete: null
    });

    try {
      // Primeiro, verificar se existem alocações para este acompanhamento
      const allocationsResponse = await axios.get(
        `${URL.api}pedagogical/follow-ups/allocations/rooms/list`,
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` },
          params: { pedagogical_follow_ups_id: itemToDelete.id }
        }
      );

      const allocations = allocationsResponse.data.data || [];

      if (allocations.length > 0) {
        // Se existem alocações, impedir a exclusão
        this.setState({ loading: false });
        toastr.error(
          "Não é possível excluir",
          "Este acompanhamento pedagógico possui alocações ativas. Remova todas as alocações primeiro antes de excluir."
        );
        return;
      }

      // Se não há alocações, prosseguir com a exclusão
      const deleteResponse = await axios.delete(
        `${URL.api}pedagogical/follow-ups/${itemToDelete.id}/delete`,
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      );

      if (deleteResponse.data.success) {
        // Remover o item da lista local
        this.setState(prevState => ({
          list: prevState.list.filter(item => item.id !== itemToDelete.id),
          loading: false
        }));

        // Mostrar mensagem de sucesso
        toastr.success("Sucesso", deleteResponse.data.message);
      } else {
        this.setState({ loading: false });
        toastr.error("Erro", deleteResponse.data.message);
      }
    } catch (error) {
      this.setState({ loading: false });
      const errorMessage =
        error.response?.data?.message ||
        "Erro ao excluir acompanhamento pedagógico";

      toastr.error("Erro", errorMessage);
      console.error("Erro ao excluir:", error);
    }
  };

  cancelDelete = () => {
    this.setState({
      showDeleteModal: false,
      itemToDelete: null
    });
  };

  render() {
    const { loading, list } = this.state;

    return (
      <>
        <Breadcrumb current={this.props.currentRoute} />
        <div className="animated fadeIn">
          {loading ? (
            <Loading top="45" left="50" />
          ) : (
            <Row>
              <div id="list" className="asdf">
                <DataTable
                  list={list || []}
                  path="/pedagogical-follow-ups/create/"
                  title="Acompanhamentos Pedagógicos"
                  header={[
                    { name: "id", denomination: "ID" },
                    { name: "name", denomination: "Nome" },
                    {
                      name: "discipline_name",
                      denomination: "Disciplina"
                    },
                    { name: "serie_name", denomination: "Série" }
                  ]}
                  insert
                  insertAction={this.insertAction}
                  action
                  btnEdit
                  editAction={this.editAction}
                  btnAllocate
                  allocateAction={this.allocateAction}
                  btnDelete
                  deletebtnAction={this.deleteAction}
                />
              </div>
            </Row>
          )}
        </div>

        {/* Modal de Confirmação de Exclusão */}
        <CModal
          show={this.state.showDeleteModal}
          onClose={this.cancelDelete}
          color="danger"
        >
          <CModalHeader closeButton>
            <CModalTitle>
              <i className="fa fa-exclamation-triangle mr-2"></i>
              Confirmar Exclusão
            </CModalTitle>
          </CModalHeader>
          <CModalBody style={{ padding: "20px" }}>
            {this.state.itemToDelete && (
              <div>
                <p className="mb-3">
                  Tem certeza que deseja excluir o acompanhamento pedagógico:
                </p>
                <div className="alert alert-light border-left border-danger">
                  <strong>"{this.state.itemToDelete.name}"</strong>
                </div>
              </div>
            )}
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" onClick={this.cancelDelete}>
              <i className="fa fa-times mr-2"></i>
              Cancelar
            </CButton>
            <CButton color="danger" onClick={this.confirmDelete}>
              <i className="fa fa-trash mr-2"></i>
              Sim, Excluir
            </CButton>
          </CModalFooter>
        </CModal>

        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  currentRoute: state.general.currentRoute
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PedagogicalFollowUpsList);
